const SOCIAL_SIGNUP_EMAIL_KEY = 'socialSignupEmail';
const SOCIAL_SIGNUP_PROVIDER_KEY = 'socialSignupProvider';

// Marks that the current visitor authenticated via Google/Apple and still needs to complete
// their Realbricks profile on the Sign Up page. Backed by localStorage (not redux) so it
// survives a refresh or a brand-new tab, matching how the rest of the signup flow persists
// state (access_token_temp, email, etc.).
export const beginSocialSignup = ({ email, provider }) => {
  localStorage.setItem(SOCIAL_SIGNUP_EMAIL_KEY, email);
  localStorage.setItem(SOCIAL_SIGNUP_PROVIDER_KEY, provider);
};

export const getSocialSignupState = () => {
  const email = localStorage.getItem(SOCIAL_SIGNUP_EMAIL_KEY);
  if (!email) {
    return null;
  }
  return { email, provider: localStorage.getItem(SOCIAL_SIGNUP_PROVIDER_KEY) };
};

export const clearSocialSignupState = () => {
  localStorage.removeItem(SOCIAL_SIGNUP_EMAIL_KEY);
  localStorage.removeItem(SOCIAL_SIGNUP_PROVIDER_KEY);
};
